module.exports = __webpack_public_path__ + "a4108b7cc2a534ec2c136a6db29ab571.ttf";